import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

function load() {
  return new Promise((res) => {
    if (window.Razorpay) return res(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => res(true);
    s.onerror = () => res(false);
    document.body.appendChild(s);
  });
}

export async function checkout(orderPath, onDone, onEnd = () => {}) {
  try {
    if (!(await load())) throw new Error("Could not load Razorpay checkout");
    const { data: o } = await api.post(orderPath);
    const rzp = new window.Razorpay({
      key: o.key_id, order_id: o.order_id, amount: o.amount, currency: o.currency, name: o.name, description: o.description, prefill: o.prefill, theme: { color: "#086B2D" },
      handler: async (resp) => { try { await api.post("/market/payments/verify", resp); toast.success("Payment successful"); onDone(); } catch (e) { toast.error(errMsg(e)); } finally { onEnd(); } },
      modal: { ondismiss: onEnd },
    });
    rzp.on("payment.failed", () => { toast.error("Payment failed. Please try again."); onEnd(); });
    rzp.open();
  } catch (e) { toast.error(errMsg(e)); onEnd(); }
}
